module.exports = __webpack_public_path__ + "static/002_Room-8d1b55c7b36d8f7f18c2cf13dbe5440c.jpg";